import styled from 'styled-components/macro';
import { Coords } from 'components/fias/fias-search/types';

export const MenuWrapper = styled.div<{
  coords: Coords;
  height: number;
}>`
  z-index: 99999;
  background-color: white;
  position: absolute;
  left: ${(props) => `${props.coords.left - 8}px`};
  top: ${(props) =>
    `${
      props.coords.top +
      7 -
      (props.coords.top + props.height + 7 > window.innerHeight
        ? props.height + 32
        : 0)
    }px`};
  border-radius: 8px;
  border: 1px solid #ced5de;
  padding: 4px 0;
  box-shadow:
    0 2px 4px 0 rgba(15, 23, 40, 0.04),
    0 4px 8px 0 rgba(15, 23, 40, 0.12),
    0 0 10px 6px rgba(15, 23, 40, 0.04);
`;

export const ScrollWrapper = styled.div<{ menuWidth: number | null }>`
  padding: 0;
  margin: 0;
  width: ${({ menuWidth }) => (menuWidth ? `${menuWidth}px` : 'fit-content')};
  max-height: 175px;
  overflow-y: auto;
  overscroll-behavior-y: none;

  ::-webkit-scrollbar {
    width: 12px;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    background: inherit;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #e4e8ee;
    border: 4px solid #ffffff;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #9da6b4;
  }
`;

export const OptionWrapper = styled.div`
  display: flex;
  background-color: #ffffff;
  padding: 0 12px;
  gap: 50px;
  align-items: center;
  justify-content: space-between;
`;

export const Text = styled.div`
  width: 100%;
  padding: 10px 0;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #1f2939;
  white-space: nowrap;
`;
